import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, useState, useMemo } from 'react';
import { useEventCallback } from '../../hooks/useEventCallback';
import { prepareProps } from '../../utils/propUtils';
import { ExpandableContainer } from '../ExpandableContainer/ExpandableContainer';
import { IconDeprecated, IconSize, IconType } from '../IconDeprecated/IconDeprecated';
import styles from './ExpandableContainerWithHeader.module.css';
export type ExpandableContainerWithHeaderProps = ComponentProps<'div'> & {
  renderHeader: (ctx: {
    expanded: boolean;
  }) => React.ReactNode;
};
export const ExpandableContainerWithHeader: FunctionComponent<ExpandableContainerWithHeaderProps> = React.memo(props => {
  const $ = _c(25);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  let renderHeader;
  if ($[2] !== t0) {
    ({
      children,
      renderHeader,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
    $[5] = renderHeader;
  } else {
    children = $[3];
    remainingProps = $[4];
    renderHeader = $[5];
  }
  const [expanded, setExpanded] = useState(false);
  let t1;
  if ($[6] !== expanded || $[7] !== renderHeader) {
    t1 = renderHeader({
      expanded
    });
    $[6] = expanded;
    $[7] = renderHeader;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const renderedHeader = t1;
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setExpanded(_temp);
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleHeaderClick = useEventCallback(t2);
  const t3 = expanded ? "angle-up" : "angle-down";
  let t4;
  if ($[10] !== t3) {
    t4 = <IconDeprecated name={t3} type={IconType.Solid} hasTextOnLeftSide={true} size={IconSize.Small} />;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleHeaderClick || $[13] !== renderedHeader || $[14] !== t4) {
    t5 = <div className={styles.header} onClick={handleHeaderClick} data-testid="ExpandableContainerWithHeader.Header">{renderedHeader}{t4}</div>;
    $[12] = handleHeaderClick;
    $[13] = renderedHeader;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== children) {
    t6 = <div className={styles.content}>{children}</div>;
    $[16] = children;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== expanded || $[19] !== t6) {
    t7 = <ExpandableContainer expanded={expanded}>{t6}</ExpandableContainer>;
    $[18] = expanded;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== remainingProps || $[22] !== t5 || $[23] !== t7) {
    t8 = <div {...remainingProps}>{t5}{t7}</div>;
    $[21] = remainingProps;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
});
function _temp(oldExpanded) {
  return !oldExpanded;
}